export default __webpack_public_path__ + "static/media/checkPointMarker.08e376c7.svg";